import { Dispatch } from "redux";
import { client2 } from "../../operationalRequest";
import { getLogoFail, getLogoPending, getLogoSuccess } from "../slice/logoSlice";

const getLogo = async () => {
    try{
        const response = await client2.get(`api/branding/logo`)
        return response;
    }catch(e){

    }
}

const getMainLogo = () => async (dispatch: Dispatch) => {
    try{
        dispatch(getLogoPending());
        const response = await getLogo();
        if(response?.status === 200){
            dispatch(getLogoSuccess(response.data?.data))
        }else{
            return dispatch(getLogoFail('Fetching Logo failed'));
        }
    }catch(e){
        if (e instanceof Error) {
            return dispatch(getLogoFail(e.message));
        } else {
            return dispatch(getLogoFail('An unknown error occurred'));
        }
    }
}

export default getMainLogo;